<template>
    <div class="loading-container" >
    <div v-if="!loadingError">
      <p class="loading-text" >Loading {{title}} ...</p>
      <br/>
      <md-progress-spinner
          md-mode="indeterminate"
          ref="spinner"
          :md-diameter="45"
          :md-stroke="3"
      ></md-progress-spinner>
    </div>
      <p v-if="loadingError">There was a problem loading {{title}}. 
        Please check your network and try again.<br/>
        If the problem persists, please contact <a href="mailto:support@frozenmountain.com">support@frozenmountain.com</a>.
      </p>
    </div>
</template>
<script>
export default {
  props: {
    title: String,
    loadingError: Boolean
  }
}
</script>
<style lang="scss" scoped>
.loading-container {
  padding-bottom: 30px;
  text-align: center;
}
.loading-text {
  font-size: 26px;
  font-weight: 500;
  line-height: 40px;
}
</style>